export default (ssn) => {
    if (ssn.length === 12) {
        return ssn;
    }

    const currentYear = new Date().getFullYear().toString().substring(2);
    const ssnYear = ssn.substring(0, 2);

    if (parseInt(ssnYear) <= parseInt(currentYear)) {
        return `20${ssn}`;
    } else {
        return `19${ssn}`;
    }
};
